<template>
	<div id="Transbank">
		<button @click="connect" ref="btnConnect" v-show="false">Obtener Token</button>
		<form method="POST" :action="connectData.url">
			<input type="hidden" name="token_ws" :value="connectData.token" />
			<button class="btn btn-danger" type="button" disabled v-if="disabledBtnPayment">
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
				Conectando con Transbank...
			</button>
			<button v-else type="submit" class="btn btn-danger">
				Pagar con Transbank
			</button>
		</form>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosSystem from '@/mixins/axiosSystem.js'
	import transbank from '@/mixins/transbank.js'

	export default {
		name: 'Transbank',
		mixins: [mixin, axiosSystem, transbank],
		props: ['amount', 'orderTokens'],
		data () {
			return {
			}
		},
		computed: {
			disabledBtnPayment() {
				if(this.connecting == true)
					return true
				if(this.connectData.url.trim() == '')
					return true
				if(this.connectData.token.trim() == '')
					return true
				return false
			}
		},
		methods: {
			connect() {
				this.connectTransbank(this.amount, this.orderTokens)
				//this.connectTransbank(50, this.orderTokens)
			},
			connectTransbankResultLocal(response) {
				if(response.data.success == true) {
					this.$emit('actionAfterGetToken', response.data.data)
				}
			}
		}
	}
</script>
